// In-browser mock backend.
// Intercepts fetch("/api/*") and serves JSON from a localStorage-persisted store.

const STORE_KEY = "ty.mock.store.v1";
const SESSION_KEY = "ty.session";

function randHex(n) {
  const b = new Uint8Array(n);
  crypto.getRandomValues(b);
  return Array.from(b).map((x) => x.toString(16).padStart(2, "0")).join("");
}

function seed() {
  const userId = crypto.randomUUID();
  const now = Date.now();
  const day = 86_400_000;

  const mkKey = (name, prefix, daysAgo, state, lastUsed) => ({
    id: crypto.randomUUID(),
    user_id: userId,
    name,
    prefix,
    created_at: new Date(now - daysAgo * day).toISOString(),
    last_used_at: lastUsed ? new Date(lastUsed).toISOString() : null,
    state,
  });

  const models = ["claude-opus-4.7", "claude-sonnet-4.5", "claude-haiku-4.5"];
  const statuses = [200, 200, 200, 200, 200, 200, 429, 200, 200, 500, 200, 200];
  const regions = ["cn-east-1", "cn-north-1", "hk-1"];
  const logs = [];
  for (let i = 0; i < 60; i++) {
    const status = statuses[i % statuses.length];
    const model = models[i % models.length];
    const latency = status === 200 ? 180 + ((i * 37) % 900) : 0;
    const tokens = status === 200 ? 400 + ((i * 311) % 12000) : 0;
    logs.push({
      id: "req_" + randHex(6),
      user_id: userId,
      status,
      model,
      latency_ms: latency,
      tokens,
      cost: ((tokens / 1_000_000) * 3.0).toFixed(4),
      region: regions[i % regions.length],
      created_at: new Date(now - i * 97_000).toISOString(),
      audit_match: true,
    });
  }

  // Daily usage buckets for analytics (last 30 days).
  const daily = [];
  for (let i = 29; i >= 0; i--) {
    const requests = 120_000 + Math.floor(Math.sin(i / 4) * 30_000) + ((i * 5381) % 20_000);
    const tokens = requests * (800 + ((i * 97) % 600));
    daily.push({
      date: new Date(now - i * day).toISOString().slice(0, 10),
      requests,
      tokens,
      cost: (tokens / 1_000_000 * 3.0).toFixed(2),
      latency_p50: 170 + ((i * 13) % 70),
      latency_p99: 380 + ((i * 37) % 150),
    });
  }

  // p99 latency samples for the last 90 days (overview chart).
  const latency_p99_90d = [];
  for (let i = 89; i >= 0; i--) {
    latency_p99_90d.push(380 + ((i * 37) % 150) + Math.floor(Math.cos(i / 7) * 40));
  }

  return {
    schema_version: 2,
    users: {
      "demo@tongyuan.ai": {
        id: userId,
        email: "demo@tongyuan.ai",
        name: "zhang",
        plan: "Pro",
        balance: "115.80",
        spent_this_month: "84.20",
        limit_this_month: "200.00",
        created_at: new Date(now - 30 * day).toISOString(),
        password: "demo1234",
        company: "同源科技",
        phone: "",
        theme: "light",
        notify_email: true,
        notify_browser: false,
      },
    },
    sessions: {},
    keys: [
      mkKey("production-app", "sk-relay-9F3A", 45, "active", now - 2_000),
      mkKey("staging", "sk-relay-7C1B", 45, "active", now - 3_600_000),
      mkKey("local-dev", "sk-relay-2D8E", 60, "active", now - 3 * day),
      mkKey("old-cli", "sk-relay-1A4F", 115, "revoked", null),
    ].map((k) => ((k.user_id = userId), k)),
    logs,
    daily,
    latency_p99_90d,
    invoices: [
      { id: "inv_2026_03", user_id: userId, period: "2026-03", amount: "164.80", status: "paid" },
      { id: "inv_2026_02", user_id: userId, period: "2026-02", amount: "142.05", status: "paid" },
      { id: "inv_2026_01", user_id: userId, period: "2026-01", amount: "98.40", status: "paid" },
    ],
    recharges: [
      { id: "rch_2026_04_01", user_id: userId, amount: "200.00", method: "alipay", status: "succeeded", created_at: new Date(now - 14 * day).toISOString() },
      { id: "rch_2026_03_02", user_id: userId, amount: "500.00", method: "wechat", status: "succeeded", created_at: new Date(now - 35 * day).toISOString() },
    ],
    alerts: [
      { id: "al_balance_low", user_id: userId, kind: "balance_low", threshold: "20", channel: "email", enabled: true },
      { id: "al_spend_daily", user_id: userId, kind: "spend_daily", threshold: "30", channel: "email", enabled: true },
      { id: "al_error_rate", user_id: userId, kind: "error_rate", threshold: "5", channel: "browser", enabled: false },
    ],
    changelog: [
      { date: "2026-04-21", tag: "feature", title: "Opus 4.7 上线", body: "claude-opus-4.7 与 Anthropic 同步上架，所有区域可用，价格 $15 / $75 per Mtok。" },
      { date: "2026-04-12", tag: "improvement", title: "p99 延迟降至 412ms", body: "cn-east-1 / hk-1 两个核心机房完成网络升级，p99 从 540ms 降到 412ms。" },
      { date: "2026-03-30", tag: "feature", title: "请求审计可导出 CSV", body: "Pro 用户现可在请求日志页一键导出 90 天审计数据。" },
      { date: "2026-03-14", tag: "fix", title: "修复 SSE 流式响应偶发断连", body: "超长对话（>4 min）会在某些客户端上 EOF。已修复。" },
      { date: "2026-02-28", tag: "feature", title: "审计日志保留期延长至 30 天", body: "原 7 天 → 30 天。所有套餐生效。" },
    ],
    status_components: [
      { id: "gateway", name: "网关", status: "ok", note: "各区域正常" },
      { id: "auth", name: "鉴权服务", status: "ok", note: "" },
      { id: "billing", name: "计费管道", status: "ok", note: "" },
      { id: "anthropic", name: "上游 · Anthropic", status: "ok", note: "api.anthropic.com 正常" },
      { id: "console", name: "控制台", status: "ok", note: "" },
    ],
    regions: [
      { id: "cn-east-1", name: "上海", status: "ok", latency: "187ms" },
      { id: "cn-north-1", name: "北京", status: "ok", latency: "203ms" },
      { id: "cn-south-1", name: "深圳", status: "ok", latency: "194ms" },
      { id: "hk-1", name: "香港", status: "ok", latency: "84ms" },
      { id: "us-west-2", name: "美西", status: "warn", latency: "1.2s" },
    ],
    models: [
      { id: "claude-opus-4.7", context: "200k", price: "$15 / $75", note: "最强能力", recommended: true },
      { id: "claude-sonnet-4.5", context: "200k", price: "$3 / $15", note: "性价比之选" },
      { id: "claude-sonnet-4.0", context: "200k", price: "$3 / $15", note: "稳定旧版" },
      { id: "claude-haiku-4.5", context: "200k", price: "$0.80 / $4", note: "高吞吐" },
      { id: "claude-haiku-4.0", context: "200k", price: "$0.25 / $1.25", note: "经济" },
    ],
    plans: [
      { name: "Starter", price: "¥0", per: "起步赠送 1M tokens", cta: "免费开始",
        features: ["全部模型可用", "标准延迟（~200ms）", "社区支持"] },
      { name: "Pro", price: "¥199", per: "/ 月起 · 按量计费", cta: "升级到 Pro", featured: true,
        features: ["专属低延迟通道", "p99 ≤ 500ms 保证", "工单支持 · 12h 响应", "审计日志导出"] },
      { name: "Enterprise", price: "面议", per: "团队 / 企业", cta: "联系我们",
        features: ["独占网关实例", "SLA 99.99% 保证", "专属客户经理", "私有部署可选"] },
    ],
    stats: {
      uptime_30d: "99.97%",
      p50_latency: "187ms",
      p99_latency: "412ms",
      consistency: "100%",
      region: "cn-east-1",
    },
  };
}

function loadStore() {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (raw) {
      const s = JSON.parse(raw);
      if (s.schema_version === 2) return s;
    }
  } catch (_) {}
  const s = seed();
  localStorage.setItem(STORE_KEY, JSON.stringify(s));
  return s;
}
function saveStore(s) { localStorage.setItem(STORE_KEY, JSON.stringify(s)); }

const json = (status, body) =>
  new Response(JSON.stringify(body), {
    status,
    headers: { "Content-Type": "application/json" },
  });

function currentToken() {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY) || "null")?.token || ""; }
  catch { return ""; }
}
function stripSecret(k) { const c = { ...k }; delete c.secret; return c; }

function getUser(store, userId) {
  for (const e of Object.keys(store.users)) {
    if (store.users[e].id === userId) return store.users[e];
  }
  return null;
}

function requireUser(store) {
  const tok = currentToken();
  const sess = store.sessions[tok];
  if (!sess) return null;
  const u = getUser(store, sess.user_id);
  if (!u) return null;
  const { password: _p, ...safe } = u;
  return safe;
}

function issueSession(store, user) {
  const token = crypto.randomUUID().replace(/-/g, "");
  const sess = {
    token,
    user_id: user.id,
    created_at: new Date().toISOString(),
    expires_at: new Date(Date.now() + 7 * 86_400_000).toISOString(),
  };
  store.sessions[token] = sess;
  return sess;
}

// Fake Claude response for playground requests.
function fakePlaygroundResponse(body) {
  const model = body.model || "claude-sonnet-4.5";
  const lastUserMsg = Array.isArray(body.messages)
    ? body.messages.filter((m) => m.role === "user").slice(-1)[0]?.content || ""
    : "";
  const text =
    typeof lastUserMsg === "string" && lastUserMsg.length > 0
      ? `(mock · ${model}) 我收到你说的「${lastUserMsg.slice(0, 80)}${lastUserMsg.length > 80 ? "…" : ""}」。真实环境下这里是模型生成的回答。`
      : `(mock · ${model}) Hello. 这是 mock 后端返回的假数据，用来演示 playground UI。接真实后端后，同样的请求会透传到 Anthropic。`;
  const inputTok = Math.max(20, Math.floor((JSON.stringify(body).length) / 4));
  const outputTok = Math.max(40, Math.floor(text.length / 2.5));
  return {
    id: "msg_" + randHex(10),
    type: "message",
    role: "assistant",
    model,
    content: [{ type: "text", text }],
    stop_reason: "end_turn",
    usage: { input_tokens: inputTok, output_tokens: outputTok },
    audit_id: "aud_" + randHex(6),
    latency_ms: 180 + Math.floor(Math.random() * 600),
  };
}

async function handle(path, opts) {
  const method = (opts.method || "GET").toUpperCase();
  const body = opts.body ? (() => { try { return JSON.parse(opts.body); } catch { return {}; } })() : {};
  const store = loadStore();

  // ---------- PUBLIC ----------
  if (path === "/api/public/stats" && method === "GET") return json(200, store.stats);
  if (path === "/api/public/regions" && method === "GET") return json(200, { regions: store.regions });
  if (path === "/api/public/models" && method === "GET") return json(200, { models: store.models });
  if (path === "/api/public/plans" && method === "GET") return json(200, { plans: store.plans });
  if (path === "/api/public/status" && method === "GET") {
    return json(200, {
      overall: "ok",
      components: store.status_components,
      regions: store.regions,
      incidents: [],
    });
  }
  if (path === "/api/public/changelog" && method === "GET") {
    return json(200, { entries: store.changelog });
  }

  // ---------- AUTH ----------
  if (path === "/api/console/register" && method === "POST") {
    const email = (body.email || "").toLowerCase().trim();
    const password = body.password || "";
    const name = (body.name || email.split("@")[0] || "").trim();
    if (!email || !password) return json(400, { error: "missing_fields" });
    if (!/.+@.+\..+/.test(email)) return json(400, { error: "invalid_email" });
    if (password.length < 6) return json(400, { error: "weak_password" });
    if (store.users[email]) return json(409, { error: "email_exists" });
    const u = {
      id: crypto.randomUUID(),
      email, name, password,
      plan: "Starter",
      balance: "10.00",
      spent_this_month: "0.00",
      limit_this_month: "50.00",
      created_at: new Date().toISOString(),
      company: "",
      phone: "",
      theme: "light",
      notify_email: true,
      notify_browser: false,
    };
    store.users[email] = u;
    const sess = issueSession(store, u);
    saveStore(store);
    const { password: _p, ...safe } = u;
    return json(201, { user: safe, session: sess });
  }

  if (path === "/api/console/login" && method === "POST") {
    const u = store.users[(body.email || "").toLowerCase()];
    if (!u || u.password !== body.password) return json(401, { error: "invalid_credentials" });
    const sess = issueSession(store, u);
    saveStore(store);
    const { password: _p, ...safe } = u;
    return json(200, { user: safe, session: sess });
  }

  if (path === "/api/console/logout" && method === "POST") {
    const tok = currentToken();
    if (tok) { delete store.sessions[tok]; saveStore(store); }
    return json(200, { ok: true });
  }

  if (path === "/api/console/forgot" && method === "POST") {
    // Always succeed (so we don't leak which emails exist).
    return json(200, { ok: true, hint: "如果该邮箱已注册，我们已经发送了重置链接。" });
  }

  // ---------- AUTH-REQUIRED ----------
  const me = requireUser(store);
  if (!me) return json(401, { error: "unauthorized" });

  if (path === "/api/console/me" && method === "GET") return json(200, me);

  if (path === "/api/console/profile" && method === "PATCH") {
    const u = store.users[me.email.toLowerCase()];
    if (!u) return json(404, { error: "not_found" });
    if (typeof body.name === "string") u.name = body.name.trim();
    if (typeof body.company === "string") u.company = body.company.trim();
    if (typeof body.phone === "string") u.phone = body.phone.trim();
    if (body.theme === "light" || body.theme === "dark") u.theme = body.theme;
    if (typeof body.notify_email === "boolean") u.notify_email = body.notify_email;
    if (typeof body.notify_browser === "boolean") u.notify_browser = body.notify_browser;
    saveStore(store);
    const { password: _p, ...safe } = u;
    return json(200, safe);
  }

  if (path === "/api/console/password" && method === "POST") {
    const u = store.users[me.email.toLowerCase()];
    if (!u) return json(404, { error: "not_found" });
    if (u.password !== body.current) return json(401, { error: "wrong_password" });
    if (!body.next || body.next.length < 6) return json(400, { error: "weak_password" });
    u.password = body.next;
    saveStore(store);
    return json(200, { ok: true });
  }

  if (path === "/api/console/overview" && method === "GET") {
    const recent = store.logs.filter((l) => l.user_id === me.id).slice(0, 5);
    return json(200, {
      metrics: {
        uptime_30d: "99.97",
        p99_live_ms: 412,
        requests_30d: "4.28M",
        spent: "¥" + me.spent_this_month,
        projection: "¥168",
      },
      latency_series: store.latency_p99_90d,
      recent_requests: recent,
    });
  }

  if (path.startsWith("/api/console/analytics") && method === "GET") {
    return json(200, {
      daily: store.daily,
      by_model: [
        { model: "claude-opus-4.7",   requests: 812_300, tokens_m: 2_430, cost: "¥48.60", share: 38 },
        { model: "claude-sonnet-4.5", requests: 1_904_200, tokens_m: 1_140, cost: "¥27.40", share: 44 },
        { model: "claude-haiku-4.5",  requests: 561_500, tokens_m: 260,   cost: "¥8.20",  share: 18 },
      ],
      by_region: [
        { region: "cn-east-1",  requests: 2_140_000, share: 50, p99: 412 },
        { region: "cn-north-1", requests: 860_000,   share: 20, p99: 438 },
        { region: "cn-south-1", requests: 520_000,   share: 12, p99: 421 },
        { region: "hk-1",       requests: 760_000,   share: 18, p99: 196 },
      ],
      errors: [
        { kind: "rate_limit_429", count: 412, pct: "0.10%" },
        { kind: "upstream_5xx",    count: 88,  pct: "0.02%" },
        { kind: "auth_401",        count: 17,  pct: "0.00%" },
      ],
    });
  }

  if (path === "/api/console/keys" && method === "GET") {
    const keys = store.keys
      .filter((k) => k.user_id === me.id)
      .map(stripSecret)
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    return json(200, { keys });
  }
  if (path === "/api/console/keys" && method === "POST") {
    const raw =
      "sk-relay-" +
      Array.from(crypto.getRandomValues(new Uint8Array(32)))
        .map((b) => "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"[b % 32])
        .join("");
    const k = {
      id: crypto.randomUUID(),
      user_id: me.id,
      name: body.name || "new-key",
      prefix: raw.slice(0, 14),
      secret: raw,
      created_at: new Date().toISOString(),
      last_used_at: null,
      state: "active",
    };
    store.keys.unshift(k);
    saveStore(store);
    return json(201, k);
  }
  const revokeMatch = path.match(/^\/api\/console\/keys\/([^/]+)\/revoke$/);
  if (revokeMatch && method === "POST") {
    const k = store.keys.find((x) => x.id === revokeMatch[1] && x.user_id === me.id);
    if (!k) return json(404, { error: "not_found" });
    k.state = "revoked";
    saveStore(store);
    return json(200, stripSecret(k));
  }

  if (path.startsWith("/api/console/logs") && method === "GET") {
    const url = new URL(path, "http://x");
    const parts = url.pathname.split("/");
    if (parts.length === 5) {
      const id = parts[4];
      const l = store.logs.find((x) => x.id === id && x.user_id === me.id);
      if (!l) return json(404, { error: "not_found" });
      return json(200, {
        log: l,
        audit: {
          upstream_endpoint: "https://api.anthropic.com/v1/messages",
          model_hash: "sha256:a3f1...e8b2",
          max_tokens: 4096,
          system_len: 4201,
          messages_len: 8940,
          match: l.audit_match,
        },
      });
    }
    const limit = Math.min(+url.searchParams.get("limit") || 50, 200);
    const statusF = url.searchParams.get("status");
    const modelF = url.searchParams.get("model");
    const logs = store.logs
      .filter((l) =>
        l.user_id === me.id &&
        (!statusF || String(l.status) === statusF) &&
        (!modelF || l.model === modelF)
      )
      .slice(0, limit);
    return json(200, { logs, total: logs.length });
  }

  if (path === "/api/console/billing" && method === "GET") {
    return json(200, {
      billing: {
        month_label: "2026 年 4 月",
        used: "¥" + me.spent_this_month,
        limit: "¥" + me.limit_this_month,
        projection: "¥168",
        next_reset: "2026-05-01",
        balance: "¥" + me.balance,
      },
      plan: me.plan,
    });
  }
  if (path === "/api/console/invoices" && method === "GET") {
    const invoices = store.invoices.filter((i) => i.user_id === me.id);
    return json(200, { invoices });
  }
  if (path === "/api/console/recharges" && method === "GET") {
    const recharges = store.recharges.filter((r) => r.user_id === me.id);
    return json(200, { recharges });
  }
  if (path === "/api/console/recharge" && method === "POST") {
    const amt = parseFloat(body.amount || "0");
    if (!(amt > 0) || amt > 100000) return json(400, { error: "invalid_amount" });
    const method_ = body.method || "alipay";
    const u = store.users[me.email.toLowerCase()];
    u.balance = (parseFloat(u.balance) + amt).toFixed(2);
    const rec = {
      id: "rch_" + randHex(4),
      user_id: u.id,
      amount: amt.toFixed(2),
      method: method_,
      status: "succeeded",
      created_at: new Date().toISOString(),
    };
    store.recharges.unshift(rec);
    saveStore(store);
    return json(201, { recharge: rec, balance: u.balance });
  }

  if (path === "/api/console/alerts" && method === "GET") {
    return json(200, { alerts: store.alerts.filter((a) => a.user_id === me.id) });
  }
  if (path === "/api/console/alerts" && method === "POST") {
    const a = {
      id: "al_" + randHex(4),
      user_id: me.id,
      kind: body.kind || "balance_low",
      threshold: String(body.threshold || "20"),
      channel: body.channel || "email",
      enabled: body.enabled !== false,
    };
    store.alerts.push(a);
    saveStore(store);
    return json(201, a);
  }
  const alertMatch = path.match(/^\/api\/console\/alerts\/([^/]+)$/);
  if (alertMatch && method === "PATCH") {
    const a = store.alerts.find((x) => x.id === alertMatch[1] && x.user_id === me.id);
    if (!a) return json(404, { error: "not_found" });
    if (typeof body.threshold !== "undefined") a.threshold = String(body.threshold);
    if (typeof body.channel === "string") a.channel = body.channel;
    if (typeof body.enabled === "boolean") a.enabled = body.enabled;
    saveStore(store);
    return json(200, a);
  }
  if (alertMatch && method === "DELETE") {
    const idx = store.alerts.findIndex((x) => x.id === alertMatch[1] && x.user_id === me.id);
    if (idx < 0) return json(404, { error: "not_found" });
    store.alerts.splice(idx, 1);
    saveStore(store);
    return json(200, { ok: true });
  }

  if (path === "/api/console/playground" && method === "POST") {
    // Simulate latency 200–900ms.
    await new Promise((r) => setTimeout(r, 200 + Math.random() * 700));
    const resp = fakePlaygroundResponse(body);
    // Record a log entry so the playground call shows up in /logs.
    const l = {
      id: "req_" + randHex(6),
      user_id: me.id,
      status: 200,
      model: body.model || "claude-sonnet-4.5",
      latency_ms: resp.latency_ms,
      tokens: resp.usage.input_tokens + resp.usage.output_tokens,
      cost: ((resp.usage.input_tokens + resp.usage.output_tokens) / 1_000_000 * 3.0).toFixed(4),
      region: "cn-east-1",
      created_at: new Date().toISOString(),
      audit_match: true,
    };
    store.logs.unshift(l);
    saveStore(store);
    return json(200, resp);
  }

  return json(404, { error: "route_not_found", path });
}

export function installMock() {
  if (typeof window === "undefined") return;
  if (window.__TY_MOCK_INSTALLED__) return;
  window.__TY_MOCK_INSTALLED__ = true;
  const origFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : input.url;
    const path = url.startsWith("http") ? new URL(url).pathname + new URL(url).search : url;
    if (path.startsWith("/api/")) {
      try { return await handle(path, init || {}); }
      catch (e) { return json(500, { error: "mock_error", message: String(e) }); }
    }
    return origFetch(input, init);
  };
}

export function resetMockStore() {
  localStorage.removeItem(STORE_KEY);
}
